/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from '../../$$_gendir/node_modules/ng2-bootstrap-modal/dist/dialog-holder.component.ngfactory';
import * as i4 from '../../$$_gendir/node_modules/ng2-bootstrap-modal/dist/dialog-wrapper.component.ngfactory';
import * as i5 from './components/catalog/catalog.component.ngfactory';
import * as i6 from './components/send-oracle-cart/send-oracle-cart.component.ngfactory';
import * as i7 from './components/cart/cart.component.ngfactory';
import * as i8 from './components/welcome/welcome.component.ngfactory';
import * as i9 from './components/detail-pdt/detail-pdt.component.ngfactory';
import * as i10 from './app.component.ngfactory';
import * as i11 from '@angular/common';
import * as i12 from '@angular/platform-browser';
import * as i13 from '@angular/forms';
import * as i14 from '@angular/http';
import * as i15 from 'ng2-bootstrap-modal/dist/dialog.service';
import * as i16 from 'ng2-pagination/dist/pagination.service';
import * as i17 from 'ngx-cookie/src/cookie-options-provider';
import * as i18 from '@angular/router';
import * as i19 from 'ngx-cookie/src/cookie.service';
import * as i20 from 'ngx-cookie/src/cookie.factory';
import * as i21 from '../../app/storage/storage';
import * as i22 from '../../app/services/auth.service';
import * as i23 from '../../app/guards/auth-token.guard';
import * as i24 from '../../app/guards-oracle/auth-oracle-token.guard';
import * as i25 from '../../app/components/catalog/catalog.component';
import * as i26 from '../../app/components/send-oracle-cart/send-oracle-cart.component';
import * as i27 from '../../app/components/cart/cart.component';
import * as i28 from '../../app/components/welcome/welcome.component';
import * as i29 from 'ng2-bootstrap-modal/dist/bootstrap-modal.module';
import * as i30 from 'ng2-pagination/dist/ng2-pagination';
import * as i31 from 'ng2-select/select/select.module';
import * as i32 from 'ng2-filter-pipe/dist/src/ng2-filter.module';
import * as i33 from 'ngx-cookie/index';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.DialogHolderComponentNgFactory,i4.DialogWrapperComponentNgFactory,
              i5.CatalogComponentNgFactory,i6.SendOracleCartComponentNgFactory,i7.CartComponentNgFactory,
              i8.WelcomeComponentNgFactory,i9.ConfirmComponentNgFactory,i10.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i11.NgLocalization,i11.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i12.DomSanitizer,i12.ɵe,[i11.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i12.DomSanitizer]),i0.ɵmpd(4608,
              i12.HAMMER_GESTURE_CONFIG,i12.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i12.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i12.ɵDomEventsPlugin(p0_0),new i12.ɵKeyEventsPlugin(p1_0),
                    new i12.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i11.DOCUMENT,i11.DOCUMENT,i11.DOCUMENT,i12.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i12.EventManager,i12.EventManager,[i12.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i12.ɵDomSharedStylesHost,i12.ɵDomSharedStylesHost,
              [i11.DOCUMENT]),i0.ɵmpd(4608,i12.ɵDomRendererFactory2,i12.ɵDomRendererFactory2,
              [i12.EventManager,i12.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,
              (null as any),[i12.ɵDomRendererFactory2]),i0.ɵmpd(6144,i12.ɵSharedStylesHost,
              (null as any),[i12.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,
              i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i12.Meta,i12.Meta,[i11.DOCUMENT]),
          i0.ɵmpd(4608,i12.Title,i12.Title,[i11.DOCUMENT]),i0.ɵmpd(4608,i13.ɵi,i13.ɵi,
              ([] as any[])),i0.ɵmpd(4608,i14.BrowserXhr,i14.BrowserXhr,([] as any[])),
          i0.ɵmpd(4608,i14.ResponseOptions,i14.BaseResponseOptions,([] as any[])),
          i0.ɵmpd(5120,i14.XSRFStrategy,i14.ɵb,([] as any[])),i0.ɵmpd(4608,i14.XHRBackend,
              i14.XHRBackend,[i14.BrowserXhr,i14.ResponseOptions,i14.XSRFStrategy]),
          i0.ɵmpd(4608,i14.RequestOptions,i14.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i14.Http,i14.ɵc,[i14.XHRBackend,i14.RequestOptions]),i0.ɵmpd(4608,i15.DialogService,
              i15.DialogService,[i0.ComponentFactoryResolver,i0.ApplicationRef,i0.Injector,
                  [2,i15.DialogServiceConfig]]),i0.ɵmpd(4608,i16.PaginationService,
              i16.PaginationService,([] as any[])),i0.ɵmpd(4608,i17.CookieOptionsProvider,
              i17.CookieOptionsProvider,[i17.COOKIE_OPTIONS,i0.Injector]),i0.ɵmpd(5120,
              i18.ActivatedRoute,i18.ɵf,[i18.Router]),i0.ɵmpd(4608,i18.NoPreloading,
              i18.NoPreloading,([] as any[])),i0.ɵmpd(6144,i18.PreloadingStrategy,
              (null as any),[i18.NoPreloading]),i0.ɵmpd(135680,i18.RouterPreloader,
              i18.RouterPreloader,[i18.Router,i0.NgModuleFactoryLoader,i0.Compiler,
                  i0.Injector,i18.PreloadingStrategy]),i0.ɵmpd(4608,i18.PreloadAllModules,
              i18.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i18.ROUTER_INITIALIZER,
              i18.ɵi,[i18.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i18.ROUTER_INITIALIZER]),i0.ɵmpd(5120,i19.CookieService,i20.cookieServiceFactory,
              [i17.CookieOptionsProvider]),i0.ɵmpd(4608,i21.Storage,i21.Storage,([] as any[])),
          i0.ɵmpd(4608,i22.AuthService,i22.AuthService,[i14.Http,i19.CookieService,
              i21.Storage]),i0.ɵmpd(4608,i23.AuthTokenGuard,i23.AuthTokenGuard,[i22.AuthService,
              i18.ActivatedRoute,i19.CookieService,i18.Router]),i0.ɵmpd(4608,i24.AuthOracleTokenGuard,
              i24.AuthOracleTokenGuard,[i22.AuthService,i21.Storage,i19.CookieService]),
          i0.ɵmpd(512,i11.CommonModule,i11.CommonModule,([] as any[])),i0.ɵmpd(1024,
              i0.ErrorHandler,i12.ɵa,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i18.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i18.ɵg,i18.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i12.ɵc(p0_0,p0_1),i18.ɵh(p1_0)];
              },[[2,i12.NgProbeToken],[2,i0.NgProbeToken],i18.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i12.BrowserModule,i12.BrowserModule,[[3,i12.BrowserModule]]),
          i0.ɵmpd(512,i13.ɵba,i13.ɵba,([] as any[])),i0.ɵmpd(512,i13.FormsModule,i13.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i14.HttpModule,i14.HttpModule,([] as any[])),
          i0.ɵmpd(1024,i18.ɵa,i18.ɵd,[[3,i18.Router]]),i0.ɵmpd(512,i18.UrlSerializer,
              i18.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,i18.ChildrenOutletContexts,
              i18.ChildrenOutletContexts,([] as any[])),i0.ɵmpd(256,i18.ROUTER_CONFIGURATION,
              {},([] as any[])),i0.ɵmpd(1024,i11.LocationStrategy,i18.ɵc,[i11.PlatformLocation,
              [2,i11.APP_BASE_HREF],i18.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i11.Location,
              i11.Location,[i11.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i18.ROUTES,
              () => {
                return [[{path:'oracle/catalog/:catalogId',canActivate:[i24.AuthOracleTokenGuard],
                    component:i25.CatalogComponent},{path:'catalog/:catalogId',component:i25.CatalogComponent,
                    canActivate:[i23.AuthTokenGuard]},{path:'cart/oracle/PunchOutOrderMessage',
                    component:i26.SendOracleCartComponent},{path:'cart/:catalogId',
                    component:i27.CartComponent},{path:'welcome/:codeErr',component:i28.WelcomeComponent},
                    {path:'',redirectTo:'welcome/1',pathMatch:'full'}]];
              },([] as any[])),i0.ɵmpd(1024,i18.Router,i18.ɵe,[i0.ApplicationRef,i18.UrlSerializer,
              i18.ChildrenOutletContexts,i11.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i18.ROUTES,i18.ROUTER_CONFIGURATION,[2,i18.UrlHandlingStrategy],
              [2,i18.RouteReuseStrategy]]),i0.ɵmpd(512,i18.RouterModule,i18.RouterModule,
              [[2,i18.ɵa],[2,i18.Router]]),i0.ɵmpd(512,i29.BootstrapModalModule,i29.BootstrapModalModule,
              ([] as any[])),i0.ɵmpd(512,i30.Ng2PaginationModule,i30.Ng2PaginationModule,
              ([] as any[])),i0.ɵmpd(512,i31.SelectModule,i31.SelectModule,([] as any[])),
          i0.ɵmpd(512,i32.Ng2FilterPipeModule,i32.Ng2FilterPipeModule,([] as any[])),
          i0.ɵmpd(512,i33.CookieModule,i33.CookieModule,([] as any[])),i0.ɵmpd(512,
              i1.AppModule,i1.AppModule,([] as any[])),i0.ɵmpd(256,i17.COOKIE_OPTIONS,
              {},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3N0ZXBoL0RvY3VtZW50cy9kZXYvbmVuZGkvbmVuZGktdmlzaW9uLWZyb250L3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9zdGVwaC9Eb2N1bWVudHMvZGV2L25lbmRpL25lbmRpLXZpc2lvbi1mcm9udC9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts